import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Toaster } from "sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Lore } from "@/components/site/Lore";
import { HowToBuy } from "@/components/site/HowToBuy";
import { Tokenomics } from "@/components/site/Tokenomics";
import { Roadmap } from "@/components/site/Roadmap";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="grain relative min-h-screen bg-[#07090e]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Lore />
        <HowToBuy />
        <Tokenomics />
        <Roadmap />
      </main>
      <Footer />
      <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: "#131a29", border: "1px solid rgba(245,158,11,.4)", color: "#f8fafc" } }} />
    </div>
  );
}

export default App;
